import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Layout } from "../pages/landing/Layout";
import { Loader } from "../components/Loader";
import { PBox, PH1, PH2, PH4 } from "../theme/BaseTheme";
import { Input, Pagination } from "antd";
import OutlineMakerCard from "./OutlineMakerCard";
import { fetchUserOutlines } from "../../actions/outline";

class OutlineMaker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            searchKey: "",
            page: parseInt(this.props.match.params.id),
            pageSize: 20,
            urlParams: new URLSearchParams(window.location.search),
            resultKey: "",
        };
    }
    async componentDidMount() {
        await this.props.fetchUserOutlines(
            this.state.urlParams,
            (this.state.page - 1) * this.state.pageSize,
            this.state.pageSize
        );
        await this.setState({
            searchKey: this.state.urlParams.get("key"),
            resultKey: "user_outlines" + "_" + this.state.urlParams.toString(),
        });
        await this.setState({ isLoading: false });
    }

    render() {
        if (this.state.isLoading) {
            return <Loader />;
        }
        return (
            <Layout>
                <Helmet>
                    <title>User Outlines</title>
                    <meta
                        name="description"
                        content="Creating beautiful outlines is now easy and quick. Patternful.ai's AI-powered outline maker make it easy for you to produce distinctive, attractive outlines for your image."
                    />
                    <meta
                        name="keywords"
                        content="Outline Maker, Outline AI, Outline Maker, Outline APP, Outline Online Maker, Outline, Patternful, Patternful AI"
                    />
                </Helmet>
                <PBox css={styles}>
                    <PH2>My Outlined Images</PH2>
                    {this.props.searchResults[this.state.resultKey]
                        ?.totalSearchOutlines !== 0 && (
                        <PBox className="patterns-container">
                            {this.props.searchResults[
                                this.state.resultKey
                            ]?.searchOutlines?.map((outline, idx) => {
                                return (
                                    <OutlineMakerCard
                                        outline_uuid={outline.outline_uuid}
                                        image_url={outline.src}
                                        prompt={outline.prompt}
                                    />
                                );
                            })}
                        </PBox>
                    )}
                    {this.props.searchResults[this.state.resultKey]
                        ?.totalSearchOutlines !== 0 && (
                        <PBox className="pattern-gallery-pagination">
                            <Pagination
                                defaultCurrent={this.state.page}
                                total={parseInt(
                                    this.props.searchResults[
                                        this.state.resultKey
                                    ]?.totalSearchOutlines
                                )}
                                pageSize={this.state.pageSize}
                                showSizeChanger={false}
                                showQuickJumper={true}
                                onChange={async (page) => {
                                    window.location.href = `/outlines/${page}?${this.state.urlParams.toString()}`;
                                }}
                            />
                        </PBox>
                    )}
                </PBox>
            </Layout>
        );
    }
}

const styles = {
    padding: "0 1.5rem",
    maxWidth: "80rem",
    margin: "2rem auto",
    "@bp2": { marginTop: "4rem" },
    "@bp4": { paddingLeft: "2rem", paddingRight: "2rem" },
    "& h2": { marginBottom: "3rem" },
    "& .patterns-search": {
        marginBottom: "3rem",
    },
    "& .patterns-container": {
        margin: "0 auto 6rem auto",
        display: "grid",
        gap: "1rem",
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        "@bp2": { gridTemplateColumns: "repeat(3, minmax(0, 1fr))" },
        "@bp4": { gridTemplateColumns: "repeat(4, minmax(0, 1fr))" },
    },
    "& .ant-card-meta-description": { color: "#1b1b1b" },
    "& .pattern-gallery-pagination": {
        display: "flex",
        justifyContent: "center",
        marginBottom: "6rem",
    },
};

function mapStateToProps(state) {
    return {
        userAccount: state.authReducer?.userAuth.userAccount,
        searchResults: state.outlineReducer?.fetchUserOutlines,
    };
}

export default connect(mapStateToProps, { fetchUserOutlines })(
    withRouter(OutlineMaker)
);
